import React from 'react';

import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { DynamicComponent } from 'ui';
import twMerge from 'utils/twMerge'

const TypographyMark = React.forwardRef(
  ({
    children, as = 'p', variant, tag, className, ...attrs
  }, ref) => (
    <DynamicComponent
      ref={ref}
      tag={tag || as}
      className={twMerge(cn(className, 'typography-mark md:px-[91px] md:font-semibold block font-bold text-base leading-[1.375] text-center py-6 px-[30px] bg-gradient-mint-light-accent3 rounded-lg'))}
      {...attrs}
    >
      {children}
    </DynamicComponent>
  ),
);

TypographyMark.displayName = 'TypographyMark';
TypographyMark.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default TypographyMark;
